<template lang="pug">
  .container
    ul(class="head-box")
      li(v-for="quote in quotes"
         :key="quote.name" 
         :class="quote.selected ? 'quotes active-quote' : 'quotes'"
         @click="(e) => changeQuote(e, quote)") {{quote.name}}
    .main
      .left
        tuple-list
      .right
        .til {{instrument.split('-').join('/')}}
        //- .assets
        //-   router-link(to="/home") 去我的资产
        .tabs
          el-tabs(v-model="side" @tab-click="handleTab" stretch)
            el-tab-pane(label="买入" name="buy")
              el-form(ref="form" :model="form" :rules="rules" class="form" label-width="120px")
                el-form-item(label="委托类型" prop="orderType")
                  el-select(v-model="form.orderType" placeholder="请选择委托类型")
                    el-option(label="限价委托" :value="0")
                    el-option(label="市价委托" :value="1")
                    el-option(label="止盈止损" :value="2")
                el-form-item(v-if="form.orderType===0" label="价格" prop="price")
                  el-input(v-model="form.price")
                el-form-item(label="百分比" prop="sizeRatio")
                  el-slider(v-model="form.sizeRatio" show-input :step="0.1")
                div(v-if="form.orderType===2")
                  el-form-item(label="触发价格" prop="triggerPrice")
                    el-input(v-model="form.triggerPrice")
                  el-form-item(label="委托类型" prop="algoType")
                    el-select(v-model="form.algoType")
                      el-option(label="限价委托" :value="1")
                      el-option(label="市价委托" :value="2")  
                  el-form-item(v-if="form.algoType===1" label="委托价格" prop="algoPrice")
                    el-input(v-model="form.algoPrice")
                el-form-item(class="btn-wrapper")
                  el-button(type="success" @click="submit('form')" size="medium") 买入
            el-tab-pane(label="卖出" name="sell")
              el-form(ref="form" :model="form" :rules="rules" class="form" label-width="120px")
                el-form-item(label="委托类型" prop="orderType")
                  el-select(v-model="form.orderType")
                    el-option(label="限价委托" :value="0")
                    el-option(label="市价委托" :value="1")
                    el-option(label="止盈止损" :value="2")
                el-form-item(v-if="form.orderType===0" label="价格" prop="price")
                  el-input(v-model="form.price")
                el-form-item(label="百分比" prop="sizeRatio")
                  el-slider(v-model="form.sizeRatio" show-input :step="0.1")
                div(v-if="form.orderType===2")
                  el-form-item(label="触发价格" prop="triggerPrice")
                    el-input(v-model="form.triggerPrice")
                  el-form-item(label="委托类型" prop="algoType")
                    el-select(v-model="form.algoType")
                      el-option(label="限价委托" :value="1")
                      el-option(label="市价委托" :value="2")  
                  el-form-item(v-if="form.algoType===1" label="委托价格" prop="algoPrice")
                    el-input(v-model="form.algoPrice")
                el-form-item(class="btn-wrapper")
                  el-button(type="danger" @click="submit('form')" size="medium") 卖出
        .cancel
          el-button(type="primary" @click="cancelAllOrders") 全部撤单
        //- .delegate-wrapper
          el-tabs(v-model="delegate" @tab-click="handleDelegateTab")
            el-tab-pane(label="当前委托" name="current")
            el-tab-pane(label="历史委托" name="history")
        
</template>

<script>
import tupleList from 'components/TupleList';
import { placeOrder, cancelAll, getDelegateList } from 'api/trade';

export default {
  components: {
    tupleList,
  },
  data() {
    return {
      quotes: [
        { name: 'USDT', selected: true },
        { name: 'BTC', selected: false },
      ],
      instrument: 'BTC-USDT',
      side: 'buy', // buy - sell
      delegate: 'current', // current - history
      form: {
        orderType: 0,
        price: '',
        sizeRatio: 0,
        triggerPrice: '',
        algoType: '',
        algoPrice: '',
      },
      rules: {},
    };
  },
  computed: {
    selectedTuple() {
      return this.quotes.find((qt) => qt.selected);
    },
  },
  watch: {
    $route(to) {
      const instrument = to.params.tuple.toUpperCase();
      this.instrument = instrument;
      this.queryDelegateList();
    },
  },
  created() {},
  mounted() {
    const instrument = this.$route.params.tuple.toUpperCase();
    this.instrument = instrument;
    const tuple = instrument.split('-');
    if (tuple.length === 2) {
      const quote = tuple[1];
      this.quotes.forEach((qt) => {
        if (qt.name.toUpperCase() === quote) {
          qt.selected = true;
        } else {
          qt.selected = false;
        }
      });
    } else {
      this.$message.error('初始化出现错误，请关闭页面重试');
    }
    // query delegate
    this.queryDelegateList();
  },
  methods: {
    changeQuote(e, quote) {
      if (quote.selected) return;
      this.quotes.forEach((item) => {
        if (quote.name === item.name) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
      if (quote.name === 'USDT') {
        this.$router.replace({ path: `/trade/btc-usdt` });
      } else {
        this.$router.replace({ path: '/trade/ltc-btc' });
      }
    },
    handleTab(side) {
      if (this.side === side.name) return;
      this.side = side.name;
      this.$refs['form'].resetFields();
    },
    async submit() {
      const res = await placeOrder({
        instrumentId: this.instrument,
        side: this.side,
        ...this.form,
        sizeRatio: this.form.sizeRatio / 100,
      }).catch((err) => this.$message.error(err.msg || '下单异常'));
      if (res.code === 0) {
        this.$message.success('下单成功');
      } else {
        this.$message.error(() => this.$message.error(res.msg || '下单失败'));
      }
    },
    async cancelAllOrders() {
      const res = await cancelAll({ instrumentId: this.instrument }).catch((err) =>
        this.$$message.error(err.msg || '撤单发生错误'),
      );
      if (res.code === 0) {
        this.$message.success('撤单成功');
      } else {
        this.$message.error(res.msg || '撤单失败');
      }
    },
    queryDelegateList() {
      // console.log(this.instrument, 'instrument in page');
      getDelegateList({ instrumentId: this.instrument })
        .then((res) => {
          if (res.code === 0 && res.data) {
            this.delegateList = res.data;
          } else {
            this.$message.error('获取委托列表失败');
          }
        })
        .catch(() => {
          this.$message.error('获取委托列表发生错误');
        });
    },
    handleDelegateTab(tab) {
      // console.log(this.delegate, tab.name);
      if (this.delegate === tab.name) return;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../styles/consts.less';

.container {
  width: 100%;
  height: 40px;
  line-height: 40px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.65);
  .head-box {
    position: relative;
    width: 1180px;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    .quotes {
      font-size: 14px;
      display: inline-block;
      margin-right: 24px;
      padding: 0 8px;
      cursor: pointer;
      text-align: center;
    }
    .active-quote {
      box-shadow: inset 0 -2px 0 0 @themeColor;
      color: @themeColor;
    }
  }
}
.main {
  position: relative;
  display: flex;
  width: 1180px;
  margin: 0 auto;
  padding-top: 24px;
  .left {
    display: block;
    width: 200px;
    margin-right: 40px;
  }
  .right {
    flex: 1;
    .til {
      font-size: 30px;
      font-weight: 400;
      height: 45px;
      line-height: 45px;
      margin-bottom: 8px;
    }
    .assets {
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 36px;
      padding: 6px 18px;
      border-radius: 8px;
      background-color: rgba(0, 0, 0, 0.03);
      color: rgba(0, 0, 0, 0.45);
      a {
        color: #3075ee;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .form {
      margin: 48px auto;
      width: 600px;
      .btn-wrapper {
        width: 100%;
        margin-top: 48px;
        .el-button {
          width: 100%;
          padding: 12px;
        }
      }
    }
  }
  .cancel {
    text-align: right;
  }
}
</style>
